import { FileTextIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import IdeaPdfExport from "components/lib/IdeaPdfExport";

import type { IdeaWithOwnerChallenge } from "../types";

type DownloadPDFActionProps = { idea: IdeaWithOwnerChallenge };

const DownloadPDFAction = ({ idea }: DownloadPDFActionProps) => {
  return (
    <IdeaPdfExport
      ideas={[idea]}
      challenge={idea?.ownerChallenge}
      popupOffset={[0, -7]}
      hidePopup
      trigger={
        <Button tooltip="Download PDF">
          <Icon icon={FileTextIcon} />
        </Button>
      }
    />
  );
};

export default DownloadPDFAction;
